import { InvoicesCommandVersionsService_invoiceCommandVersionsServiceGetQuery } from '@festina/moneyin-general-types/moneyin/hooks/InvoicesCommandVersionsService_invoiceCommandVersionsServiceGetQuery'

export const useFetchInvoiceCommandVersions =
  InvoicesCommandVersionsService_invoiceCommandVersionsServiceGetQuery.useSuspenseQuery
